import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from '../environment';
import { Contact, CCPaymentMethod } from '../interfaces';
import { Welcome } from '../interfaces/welcome';

export const EmailAPI = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: env.apiUrl,
  }),
  endpoints: (build) => ({
    sendContactMessage: build.mutation<any, Contact>({
      query: (body) => ({
        url: '/contact',
        method: 'POST',
        body,
      }),
    }),
    sendPaymentMethodMessage: build.mutation<any, CCPaymentMethod>({
      query: (body) => ({
        url: '/payment/method',
        method: 'POST',
        body,
      }),
    }),
    sendWelcomeMessage: build.mutation<any, Welcome>({
      query: (body) => ({
        url: '/welcome',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useSendContactMessageMutation,
  useSendPaymentMethodMessageMutation,
  useSendWelcomeMessageMutation,
} = EmailAPI;